export default {
  'edit.title': 'Módulos y permisos',

  'modules.asset.title': 'Activo',
  'modules.asset.description': 'Controle los activos para atención del equipo en campo',
  'modules.asset.fields.editAndImport': 'Registro de mis activos',
  'modules.asset.fields.listAndExport': 'Visualizar y exportar mis activos',
  'modules.asset.fields.delete': 'Eliminar mis activos',

  'modules.dashboard.title': 'Métricas',
  'modules.dashboard.description': 'Insights y dashboard para control gerencial',
  'modules.dashboard.fields.dashboard': 'Tener visión de mi equipo de campo con el dashboard',
  'modules.dashboard.fields.complianceTab': 'Habilitar aba de eficiencia en el dashboard',

  'modules.user.title': 'Usuario',
  'modules.user.description': 'Controle sus usuarios Btime',
  'modules.user.fields.editAndImport': 'Registro de mis usuarios',
  'modules.user.fields.listAndExport': 'Visualizar y exportar mis usuarios',
  'modules.user.fields.delete': 'Eliminar mis usuarios',
  'modules.user.fields.createNewUsersForClients': 'Permitir que cree usuarios para mis clientes',
  'modules.user.fields.createNewUsersForThirdParty': 'Permitir que cree usuarios para mis colaboradores tercerizados',

  'modules.customer.title': 'Cliente',
  'modules.customer.description': 'Controle los clientes para atención del equipo en campo',
  'modules.customer.fields.editAndImport': 'Registro de mis clientes',
  'modules.customer.fields.listAndExport': 'Visualizar y exportar mis clientes',
  'modules.customer.fields.delete': 'Eliminar mis clientes',
  'modules.customer.fields.controlSegments': 'Mantener segmentación de clientes',
  'modules.customer.fields.controlWaller': 'Mantener cartera de clientes',
  'modules.customer.fields.controlRequest': 'Activar campo adicional de solicitante en las órdenes de servicio',

  'modules.checkList.title': 'Cuestionario',
  'modules.checkList.description': 'Cree formularios y estandarice sus cuestionarios',
  'modules.checkList.fields.editAndImport': 'Registro de mis cuestionarios',
  'modules.checkList.fields.listAndExport': 'Visualizar y exportar los cuestionarios',
  'modules.checkList.fields.delete': 'Eliminar mis cuestionarios',
  'modules.checkList.fields.addQuestions': 'Permitir vincular preguntas de un cuestionario',

  'modules.serviceOrder.title': 'Actividad',
  'modules.serviceOrder.description': 'Controle los procesos de atención',
  'modules.serviceOrder.fields.editAndImport': 'Registro de mis órdenes de servicio',
  'modules.serviceOrder.fields.listAndExport': 'Visualizar y exportar órdenes de servicio',
  'modules.serviceOrder.fields.delete': 'Eliminar mis órdenes de servicio',
  'modules.serviceOrder.fields.replyRequester': 'Responder solicitantes de las actividades',
  'modules.serviceOrder.fields.ownedOnly': 'Visualizar solo mis órdenes de servicio',
  'modules.serviceOrder.fields.newSOWithUser': 'Crear actividades para cualquier usuario en mobile',
  'modules.serviceOrder.fields.validateAndApprove': 'Validar y aprobar la atención de mi equipo de campo',
  'modules.serviceOrder.fields.transport': 'Deseo activar información de transporte para atención',
  'modules.serviceOrder.fields.priority': 'Deseo activar priorización de atención de mi equipo de campo',
  'modules.serviceOrder.fields.actionPlan': 'Deseo activar tratamiento de no conformidad con 5W2H',
  'modules.serviceOrder.fields.fastSO':
    'Deseo activar la creación de órdenes de servicio rápidas para mi equipo de campo',
  'modules.serviceOrder.fields.acceptView': 'Ocultar pantalla de aceptación en la app',
  'modules.serviceOrder.fields.executionView': 'Ocultar confirmación de la ejecución en la app',
  'modules.serviceOrder.fields.geofenceRadius': 'Deseo activar cerca digital para mi equipo de campo',
  'modules.serviceOrder.fields.review': 'Deseo activar la configuración de revisión de mis actividades',
  'modules.serviceOrder.fields.retroactive': 'Deseo activar la creación de actividades retroactivas',
  'modules.serviceOrder.fields.publicExecution': 'Permite enviar enlace público de ejecución de actividades',

  'modules.recurrence.title': 'Recurrencias',
  'modules.recurrence.description': '-',

  'modules.refund.title': 'Reembolsos',
  'modules.refund.description': 'Controle los gastos de su equipo de campo',
  'modules.refund.fields.editAndImport': 'Registro de reembolsos',
  'modules.refund.fields.listAndExport': 'Visualizar y exportar los reembolsos',
  'modules.refund.fields.delete': 'Eliminar los reembolsos',
  'modules.refund.fields.approve': 'Aprobar reembolsos registrados',

  'modules.map.title': 'Mapa',
  'modules.map.description': 'Visualización en mapa de su equipo y clientes',

  'modules.fleet.title': 'Flota',
  'modules.fleer.description': '-',

  'modules.skill.title': 'Skill',
  'modules.skill.description': 'Controle las competencias de su equipo en campo',

  'modules.calendar.title': 'Calendario',
  'modules.calendar.description': 'Controle los agendamientos de servicio',

  'modules.userCustomerRelation.title': 'Relacionamiento de cliente',
  'modules.userCustomerRelation.description': '-',

  'modules.workflow.title': 'Workflow',
  'modules.workflow.description': '-',

  'modules.thirdParty.title': 'Terceros',
  'modules.thirdParty.description': '-',

  'modules.integration.title': 'Integraciones',
  'modules.integration.description': 'Integre Btime con otros sistemas',
  'modules.integration.fields.crud': 'Crear webhooks para integrar mis sistemas',
  'modules.integration.fields.api': 'Utilizar API abierta de Btime',
  'modules.integration.fields.delete': 'Eliminar mis webhooks',

  'modules.segment.title': 'Segmentos',
  'modules.segment.description': 'Control de los segmentos',
  'modules.segment.fields.editAndImport': 'Registro de mis segmentos',
  'modules.segment.fields.listAndExport': 'Visualizar y exportar mis segmentos',
  'modules.segment.fields.delete': 'Eliminar mis segmentos',

  'modules.place.title': 'Locales',
  'modules.place.description': 'Control de los registros de locales',
  'modules.place.fields.editAndImport': 'Registro de mis locales',
  'modules.place.fields.listAndExport': 'Visualizar y exportar mis locales',
  'modules.place.fields.delete': 'Eliminar mis locales',
  'modules.place.fields.placeLevel': 'Registro de niveles de locales',

  'modules.person.title': 'Personas',
  'modules.person.description': 'Control de los registros de personas',
  'modules.person.fields.editAndImport': 'Registro de mis personas',
  'modules.person.fields.listAndExport': 'Visualizar y exportar mis personas',
  'modules.person.fields.delete': 'Eliminar mis personas',
  'modules.person.fields.placeLevel': 'Registro de niveles de personas',

  'modules.fleet.title': 'Flota',
  'modules.fleet.description': 'Control de los registros de Flotas',
  'modules.fleet.fields.editAndImport': 'Registro de mis flotas',
  'modules.fleet.fields.listAndExport': 'Visualizar y exportar mis flotas',
  'modules.fleet.fields.delete': 'Eliminar mis flotas',
  'modules.fleet.fields.placeLevel': 'Registro de niveles de Flotas',

  'modules.form.title': 'Formularios',
  'modules.form.description': 'Control de los registros y envío de formularios',
  'modules.form.fields.editAndImport': 'Registro de mis formularios',
  'modules.form.fields.listAndExport': 'Visualizar y exportar mis formularios',
  'modules.form.fields.delete': 'Eliminar mis formularios',
  'modules.form.fields.share': 'Compartir y enviar mis formularios',

  'modules.template.title': 'Plantillas de documentos',
  'modules.template.description': 'Control de los registros de plantillas',
  'modules.template.fields.edit': 'Registro de mis plantillas',

  'modules.templateRecord.title': 'Generación de documentos',
  'modules.templateRecord.description': 'Control de los registros de documentos',
  'modules.templateRecord.fields.edit': 'Generar PDFs',

  'modules.qrcode.title': 'QR Codes',
  'modules.qrcode.description': 'Gestión de QR Codes',

  'modules.nonCompliance.title': 'No conformidad',
  'modules.nonCompliance.description': 'Visualizar todas las no conformidades'
}
